module.exports = __webpack_public_path__ + "img/ico_circle_segment_white.46b3eb4d.svg";